.iconButton:global(.calmlens-button-button) {
  padding: 0;
  width: var(--control-height-md);
  aspect-ratio: 1;

  &:global(.calmlens-button-size-sm) {
    width: var(--control-height-sm);
  }

  &:global(.calmlens-button-size-lg) {
    width: var(--control-height-lg);
  }

  &[aria-pressed="true"] {
    background: var(--color-primary-soft-opaque);
    border-color: var(--color-primary);
    color: var(--color-primary);
  }

  svg {
    min-width: 1.25em;
    min-height: 1.25em;
  }
}
